<style>
.large-button {
  width: 260px
}
</style>

<style scoped>
.container1234 {
  display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-around; margin: 16px 0px;
}
.item1234 {
  flex: 1 0 300px; min-width: 300px; display: flex; align-items: flex-start; padding: 16px;
}

.right1234 {
  display: inline-block; padding: 4px 16px;
}

.badge1234 {
  font-weight: 500;
  flex: 0 0 auto;
  display: inline-block;
  color: white;
  background-color: #2196F3;
  border-radius: 50%;
  height: 1.5em;
  width: 1.5em;
  font-size: 1.5em;
  line-height: 1.5em;
  text-align:center;
}


.date-limit {
  display: flex; flex-direction: column; align-items: center;
}
</style>

<template>
  <div v-if="initialized">

    <!--Welcome Message-->
    <div v-if="documentReady">
      <h2>Your file is finished</h2>
    </div>
    <div v-else-if="isWaitingWire">
      <h2>We are wainting for the payment</h2>
    </div> 
    <div v-else-if="paymentDone">
      <h2>Your file has to be completed</h2>
    </div> 
    <div v-else-if="isInReview">
      <h2>Your file is processing</h2>
    </div> 

    <div v-else-if="!hasValues">
      <div class="centered-child" style="padding-bottom: 16px">
        <div style="width: 100%; max-width: 200px">
        <img src="/static/justice.svg" width="100%">
        </div>
      </div>

      <h2 style="text-align: center">Simplified procedure to appeal after a visa refusal.</h2>

      <h3 style="text-align: center;font-size:1.3em;font-weight:400;">Your appeal file in 4 steps</h3>

      <div class="container1234">

        <div class="item1234">
          <span class="badge1234">1</span>
          <div class="right1234">
            <span style="font-size: 1.3em;">Qualification</span>
            <span style="display: block; margin-top: 4px">Thanks to our online questionnaire, you will check if you are still able to appeal and see which appeal procedure you need.</span>
          </div>
        </div>

        <div class="item1234">
          <span class="badge1234">2</span>
          <div class="right1234">
            <span style="font-size: 1.3em;">Payment</span>
            <span style="display: block; margin-top: 4px">Choose one service (standard or premium) and make the payment online or by order money.</span>

          </div>
        </div>

        <div class="item1234">
          <span class="badge1234">3</span>
          <div class="right1234">
            <span style="font-size: 1.3em;">Creation of the file</span>
            <span style="display: block; margin-top: 4px">You prepare your file by adding all the documents suggested according to your situation.</span>
          </div>
        </div>

        <div class="item1234">
          <span class="badge1234">4</span>
          <div class="right1234">
            <span style="font-size: 1.3em;">Processing and mailing</span>
            <span style="display: block; margin-top: 4px">Your file is ready and has been checked by our experts. You just need to print it and send it to the address indicated.</span>
          </div>
        </div>

      </div>

    </div>

    <div v-else>
      <h2>Continue your file</h2>
    </div>




    <!--User Form-->
    <div v-if="!displayUserForm"  style="margin: 16px 0px">
      <div v-if="values && (values.id_user_prenom || values.id_user_nom || values.id_user_mail || values.id_user_phnum)" >

        <div class="light-frame" style="display: flex; justify-content: space-between; ">
          <div style="padding: 16px 16px">
            <div class="md-headline">{{values.id_user_prenom}} {{values.id_user_nom}}</div>
            <div class="md-caption">{{values.id_user_adress_street}}, {{values.id_user_adress_city}}, {{values.id_user_adress_country}}</div>
            <div class="md-caption">{{values.id_user_mail}}</div>
            <div class="md-caption">{{values.id_user_phnum}}</div>
          </div>

          <div style="padding: 16px 0px">
            <md-button class="md-icon-button" @click="displayUserForm = true">
              <md-icon>mode_edit</md-icon>
            </md-button>
          </div>

        </div>
      </div>
    </div>

    <div v-else class="light-frame" style="padding: 16px; margin: 16px 0px">
      <user-form ref="userForm"
        :questions="questions"
        :values="values"
        :error-messages="errorMessages"
        >
      </user-form>
      <div v-if="userFormHasError" style="color: red">
        Complètez le formulaire.
      </div>
      <div class="centered-child" style="margin-top: 48px">
        <md-button class="md-raised md-primary large-button" @click="onClickValidate()">Confirm</md-button>
      </div>
    </div>
    <!--End User Form-->


    <!--Date Limite -->
    <div v-if="dateLimite" class="light-frame date-limit" :style="{color: remainingDays > 0 && remainingDays <= 7 ? 'white' : 'black', backgroundColor: remainingDays > 0 && remainingDays <= 7 ? 'red' : 'white'}">
      <div style="font-size: 1.1em; text-align: center; padding: 16px 8px">Deadline to send your appeal <b>{{dateLimiteStr}}</b></div>
      <div v-if="remainingDays > 0" style="font-size: 1.5em; font-weight: 500; padding: 0px 8px 16px 8px">Only {{remainingDaysStr}}</div>
    </div>



    <!--Purchases-->
    <div v-for="purchase in purchases">

      <md-card v-if="purchase == 'VISA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Help with your visa application file</div>
            <div class="md-subhead">Help with your visa application file. 10 minutes questionnaire, cover letter, online procedure, online support.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="purchase == 'CRRV'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title"> Appeal to the Appeals Board on Visa Refusals</div>
            <div class="md-subhead"> appeal to the Appeals Board on Visa Refusals.  10 minutes questionnaire, cover letter, online procedure, online support.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="purchase == 'TA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Administrative Court of Nantes</div>
            <div class="md-subhead">Appeal to the Administrative Court of Nantes.  10 minutes questionnaire, cover letter, online procedure, online support</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="purchase == 'PREMIUM'" class="light-frame">
        <md-card-header >
          <md-card-header-text>
            <div class="md-title"> Premium Pack </div>
          <div class="md-subhead">You are assisted and defended by a specialised lawyer.</div>
            </md-card-header-text>
          <md-card-media>
            <img src="/static/lawyer.svg">
          </md-card-media>
        </md-card-header>
      </md-card>
    </div>
    <!--End Purchases-->

    <div v-if="documentReady">
      <p style="text-align: left;">
         Your file has been checked by our lawyers.
      </p>
      <div v-if="purchases.includes('CRRV')" class="centered-child">
        <p style="text-align: left;">
          You can now <strong>download</strong>
          the document, print it in <strong>1 copy</strong>,  <strong>sign</strong> it, add the <strong>attached documents</strong> and send it
          by <strong>registered post with acknowledgement of receipt</strong> to this address :
        </p>

        <p style="display: inline-block; text-align: center; border: 1px solid; padding: 16px 32px;">
          Commission contre les refus de visa d'entrée en France<br>
          BP 83609<br>
          44036 Nantes Cedex 01<br>
          France<br>
        </p>
      </div>
      <div v-else-if="purchases.includes('TA')" class="centered-child">
        <p style="text-align: left;">
            You can now <strong>download</strong>
           the document, print it in <strong>4 copies</strong>,  <strong>sign</strong> it, add the<strong>attached documents</strong>  and send it
            by <strong>registered post with acknowledgement of receipt</strong> to this address:
        </p>
        <p style="display: inline-block; text-align: center; border: 1px solid; padding: 16px 32px;">
          Tribunal administratif de Nantes, Monsieur et Madame le Greffier<br>
          BP 24111<br>
          44041 Nantes Cedex 1<br>
          France<br>
        </p>
      </div>
    </div>

    <div v-else-if="paymentDone">
      <p>
       Your file is almost ready. You need to add the attached documents whiwh will support the contestation. Once donce, yor file will be sent to our experts who will verify everything and send it back to you by email.
      </p>
    </div>
    
    <div v-else-if="isWaitingWire">
      <p>
        We are waiting for your payment before preparing all the documents.
      </p>
    </div>

    <div v-else-if="isInReview">
      <p>
        Your file is being processing by our team. We will send you an email when it will be ready to be sent to the administration.
      </p>
    </div>
    

    <div v-else-if="hasValues">
      <p>
       First of all, you can fill your file in order to propose you the best service according to your situation.
      </p>
    </div>


    <!-- Wait Wire -->
    <div v-if="isWaitingWire">
      <p style="color: white; background-color: red; text-align: center; padding: 16px; font-size: 1.2em; font-weight: 500">
       We are wainting for the payment of {{values.id_virement_amount}}&euro; before finishing your file.
      </p>
      <div style="text-align: center; padding: 16px 16px 8px 16px; font-size: 1.2em; border: 1px solid #eee">
       If you have a friend who have a payment card like MasterCard, VISA ou AMEX, he/she can pay for you.
        Send him/her this link:
        <br/>
        <br/>
        <div class="pay-url">{{payURL}}</div>
        <div style="margin-top: 8px; display: flex; flex-wrap: wrap; justify-content: center">
          <md-button @click="onCopy()">Copy</md-button>
          <md-button @click="onEmail()">Send by email</md-button>
        </div>

      </div>

      <div v-if="values.id_virement_type == 'wire'" class="light-frame visa-frame">
        <h3>Payment by international bank transfer</h3>
        <p>To proceed the pyament you have to make a international bank transfer on GetMyVisaToFrance account</p>
        <p style="padding-left: 16px">
          <b>Amount: {{values.id_virement_amount}}&euro;</b><br>
          <b>IBAN : DE06100110012626269080</b><br>
          <b>BIC/SWIFT : NTSBDEB1XXX</b>
        </p>
      </div>

      <div v-if="values.id_virement_type == 'mandat-express'" class="light-frame visa-frame">
        <h3>Payment by Express Money Order </h3>
        <p>To proceed the payment you have to go <u>in a post office</u> to make an international Express Money Order 
         on the OCTAGRAM SAS account, GetMyVIsaToFrance oprator.</p>

        <p style="padding-left: 16px">
          <b>AMount: {{values.id_virement_amount}}&euro;</b><br>
          <b>Name of the company : OCTAGRAM SAS</b><br>
          <b>Adress : 59 rue Chardon Lagache 75016 Paris</b>
        </p> 
      </div>

      <div v-if="values.id_virement_type == 'western-union'" class="light-frame visa-frame">
        <h3>Payment by Western Union</h3>
        <p>To proceed the payment you have to go <u>in a Western Union agency</u> to make the transfer
         to the legal representative of the OCTAGRAM SAS company, GetMyVIsaToFrance oprator.</p>
        <p style="padding-left: 16px">
          <b>Amount: {{values.id_virement_amount}}&euro;</b><br>
          <b>First name : Alexandre, René, Georges</b><br>
          <b>Last name : GRUX</b><br>
          <b>Adress : 59 rue Chardon Lagache 75016 Paris</b>
        </p>
      </div>

      <p style="color: white; background-color: #2196F3; text-align: center; padding: 16px; font-size: 1.2em; font-weight: 500">
       incase of problem with the payment, please call our account service&nbsp;au&nbsp;:<br>
        <a style="color: white; font-size: 1.4em; line-height: 1.5em" href="tel:+33977218845">+33 977 218 845</a>
      </p>
    </div>
    <!-- End Wait Wire -->

    <div v-else-if="documentReady">
      <div class="centered-child" style="margin-top: 0px; align-items: center; flex-direction: column">
        <md-button class="md-accent" @click="onClickView()">Download the document</md-button>
     </div>
    </div>

    <div v-else-if="!isInReview" class="centered-child" style="margin-top: 32px">
      <div v-if="hasValues">
        <md-button class="md-raised md-primary large-button" @click="onClickComplete()">Complete your file</md-button>

        <div v-if="purchases && purchases.length > 0">
          <md-button class="md-raised md-primary large-button" @click="onClickConsult()">Change your answers</md-button>
        </div>

        <div v-if="hasValueFiles">
          <md-button class="md-raised md-primary large-button" @click="onClickRender()">Finish your appeal</md-button>
        </div>

      </div>

      <div v-else style="display: flex; width: 100%; align-items: center; flex-direction: column">
        <div>
          <md-button class="md-raised md-primary large-button" @click="onClickStart()">Continue</md-button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import ServiceAccess from '../service/ServiceAccess'
import UserForm from '../components/UserForm'
import moment from 'moment'


export default {

  components: {
    'user-form': UserForm
  },

  data: function () {
    return {
      displayUserForm: false,
      userFormHasError: false,
      initialized: false,

      purchases: [],
      questions: {},
      errorMessages: {},
      values: null,
      stage: null,
      screens: null,

      hasValues: false,
      hasValueFiles: false,

      payURL: '...'
    }
  },

  computed: {
    isWaitingWire: function () {
      return this.stage && this.stage.name === 'wait-payment'
    },
    paymentDone: function () {
      return this.stage && this.stage.name === 'payment-done'
    },
    isInReview: function () {
      return this.stage && this.stage.name === 'in-review'
    },
    documentReady: function () {
      return this.stage && this.stage.name === 'document-ready'
    },
    remainingDays: function () {
      let days = this.dateLimite.diff(moment(), 'days') + 1 // assuming day start a 00:00
      return days
    },
    remainingDaysStr: function () {
      let days = this.remainingDays
      if (days > 1) {
        return days + ' jours'
      } else {
        return days + ' jour'
      }
    },
    dateLimite: function () {
      moment.locale('fr')
      if (this.values.id_when_refus_crrv) {
        return moment(this.values.id_when_refus, 'YYYY-MM-DD').add(2, 'months').subtract(5, 'days')
      } else if (this.values.id_when_crrv) {
        return moment(this.values.id_when_crrv, 'YYYY-MM-DD').add(4, 'months').subtract(5, 'days')
      } else if (this.values.id_when_refus) {
        return moment(this.values.id_when_refus, 'YYYY-MM-DD').add(2, 'months').subtract(5, 'days')
      } else if (this.values.id_when_app) {
        return moment(this.values.id_when_app, 'YYYY-MM-DD').add(4, 'months').subtract(5, 'days')
      }
    },
    dateLimiteStr: function () {
      let date = this.dateLimite
      if (date) {
        return date.format('Do MMMM YYYY')
      } else {
        return null
      }
    }
  },

  updated: function () {
    this.updateBinding()
  },

  created: function () {
    global.navigationBarBus.$emit('navigation-display-back', false)
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.purchases(this.$route.params.sessionId),
      ServiceAccess.instance.loadStage(this.$route.params.sessionId),
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadScreens(),
      ServiceAccess.instance.loadErrorMessages(),
      ServiceAccess.instance.loadQuestions(),
      ServiceAccess.instance.checkoutFriendURL(this.$route.params.sessionId)
    ]
    Promise.all(promises).then(responses => {
      let [purchases, stage, values, screens, errorMessages, questions, url] = responses
      this.values = values
      this.stage = stage
      global.navigationBarBus.$emit('display-save', Object.keys(values).length > 0 && values.id_user_mail == null)

      this.purchases = purchases
      this.screens = screens
      this.errorMessages = errorMessages
      this.questions = questions
      this.payURL = url
      this.initialized = true
      this.updateBinding()
    })
  },

  methods: {
    updateBinding: function () {
      this.hasValues = this.values && Object.keys(this.values).length > 0
      this.hasValueFiles = this.values && this.values._files && Object.keys(this.values._files).length > 0
    },

    screen: function (screenId) {
      let target = screenId || 'start'
      return '/f/' + this.$route.params.sessionId + '/' + target
    },


    // synchroniser avec le wf
    entryScreenId: function () {
      if (this.values.id_howlong >= 0) {
        if (this.values.id_howlong === 0) { // long sejour
          if (this.values.id_why === 0) {
            return 'parcours etudiant'
          } else if (this.values.id_why === 1) {
            return 'parcours conjoint'
          } else if (this.values.id_why === 2) {
            return 'parcours stage formation'
          } else if (this.values.id_why === 3) {
            return 'parcours etablissement'
          } else if (this.values.id_why === 4) {
            return 'parcours professionnelle'
          } else if (this.values.id_why === 5) {
            return 'parcours mariage'
          } else if (this.values.id_why === 6) {
            return 'parcours visa retour'
          } else if (this.values.id_why === 7) {
            return 'parcours medicale'
          } else if (this.values.id_why === 8) {
            return 'parcours fonctions officielles'
          } else if (this.values.id_why === 9) {
            return 'parcours autre'
          }
        } else { // cours sejour
          if (this.values.id_why_short === 0) {
            return 'parcours etude court'
          } else if (this.values.id_why_short === 1) {
            return 'parcours famille court'
          } else if (this.values.id_why_short === 2) {
            return 'parcours tourisme court'
          } else if (this.values.id_why_short === 3) {
            return 'parcours affaire court'
          } else if (this.values.id_why_short === 4) {
            return 'parcours culture court'
          } else if (this.values.id_why_short === 5) {
            return 'parcours sport court'
          } else if (this.values.id_why_short === 6) {
            return 'parcours officiel court'
          } else if (this.values.id_why_short === 7) {
            return 'parcours medicale court'
          } else if (this.values.id_why_short === 8) {
            return 'parcours transit court'
          } else if (this.values.id_why_short === 9) {
            return 'parcours transit aero court'
          } else if (this.values.id_why_short === 10) {
            return 'parcours autre court'
          }
        }
      } else {
        return 'parcours visa simple'
      }
    },

    startScreen: function () {
      if (this.purchases && this.purchases instanceof Array && (this.purchases.includes('VISA') || this.purchases.includes('CRRV') || this.purchases.includes('TA') || this.purchases.includes('PREMIUM'))) {
        return this.screen(this.entryScreenId())
      }
    },

    latestScreen: function () {

      if (this.purchases && this.purchases instanceof Array && (this.purchases.includes('VISA') || this.purchases.includes('CRRV') || this.purchases.includes('TA') || this.purchases.includes('PREMIUM'))) {
        let screenId = this.screens.lastestScreenId(this.values, this.entryScreenId())
        return this.screen(screenId)
      } else {
        let screenId = this.screens.lastestScreenId(this.values)

        if (screenId) {
          return this.screen(screenId)
        } else {
          return this.screen()
        }
      }

    },


    onClickStart: function () {
      ServiceAccess.instance.track(this.$route.params.sessionId, 'start')
      this.$router.push(this.screen())
    },

    onClickComplete: function () {
      this.$router.push(this.latestScreen())
    },

    onClickConsult: function () {
      this.$router.push(this.startScreen())
    },


    onCopy: function () {
      let selection = window.getSelection()
      selection.removeAllRanges()
      let payUrlSpan = this.$el.querySelector('.pay-url').firstChild
      let range = document.createRange()
      range.selectNode(payUrlSpan)
      selection.addRange(range)

      try {  
        document.execCommand('copy')
      } catch (err) {  
        console.error('Unable to copy', err)
      }
    },
    onEmail: function () {
      window.open('mailto:?subject=Aide pour dossier de visa pour la France&body=Bonjour,%0A%0AAfin de compléter ma procédure de visa pour la France, il faut effectuer un paiement en utilisant le lien sécurisé suivant :%0A' + this.payURL)
    },

    onClickView: function () {
      let renderURL = ServiceAccess.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + this.values.document_livrable
      console.log('RenderURL', renderURL)
      window.open(renderURL, '_blank')
    },

    onClickRender: function () {
      if (this.paymentDone) {
        ServiceAccess.instance.track(this.$route.params.sessionId, 'review')
        let screenId = this.screens.lastestScreenId(this.values, 'relecture')
        this.$router.push(this.screen(screenId))
      } else {
        global.navigationBarBus.$emit('info', 'Nous n\'avons toujours pas encore reçu votre paiement. Nous ne pouvons pas finaliser votre dossier pour le moment.')
      }
    },

    onClickValidate: function () {
      this.userFormHasError = this.$refs.userForm.hasError()
      if (!this.userFormHasError) {
        ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)
        this.displayUserForm = false
      }


    }

  }

}
</script>



// WEBPACK FOOTER //
// Home.vue?d95ce0c2